import { render, staticRenderFns } from "./DealList.vue?vue&type=template&id=4f0c0d50&scoped=true"
import script from "./DealList.vue?vue&type=script&lang=js"
export * from "./DealList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c0d50",
  null
  
)

export default component.exports